import { Upload, FileText, Download, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { getFileUrl } from '../lib/api';

const isImage = (contentType) => contentType?.startsWith('image/');

export function TaskAttachments({ attachments = [], canUpload, uploading, onUpload, onDelete, isAdmin, isDeveloper }) {
  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-2">
        <Label>Attachments ({attachments.length})</Label>
        {canUpload && (
          <label className="cursor-pointer">
            <input
              type="file"
              multiple
              onChange={onUpload}
              className="hidden"
              accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.zip"
            />
            <Button variant="outline" size="sm" disabled={uploading} asChild>
              <span>
                <Upload size={14} className="mr-1" />
                {uploading ? 'Uploading...' : 'Upload'}
              </span>
            </Button>
          </label>
        )}
      </div>

      {attachments.length > 0 && (
        <div className="grid grid-cols-4 gap-2">
          {attachments.map(att => (
            <div
              key={att.id}
              className="relative group border border-[#E0E0E0] rounded-lg overflow-hidden"
            >
              {isImage(att.content_type) ? (
                <img
                  src={getFileUrl(att.storage_path)}
                  alt={att.filename}
                  className="w-full h-24 object-cover"
                />
              ) : (
                <div className="w-full h-24 flex flex-col items-center justify-center bg-[#F5F5F5]">
                  <FileText size={24} className="text-[#666666]" />
                  <span className="text-xs text-[#666666] mt-1 truncate max-w-full px-2">
                    {att.filename}
                  </span>
                </div>
              )}
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-2">
                <a
                  href={getFileUrl(att.storage_path)}
                  download={att.filename}
                  className="p-1 bg-white rounded"
                >
                  <Download size={16} />
                </a>
                {(isAdmin || isDeveloper) && (
                  <button
                    onClick={() => onDelete(att.id)}
                    className="p-1 bg-white rounded text-red-500"
                  >
                    <Trash2 size={16} />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
